import React from 'react';

import kakao_icon from '../asset/img/linktodata_kakao_img.jpg';
import toss_icon from '../asset/img/linktodata_toss_img.jpg';
import naver_icon from '../asset/img/linktodata_naver_img.svg';
import kakaobank_icon from '../asset/img/linktodata_kakaobank_img.png';

import kakaoMImg from '../asset/img/linktodata_m_kakao_img.jpg';
import tossMImg from '../asset/img/linktodata_m_toss_img.jpg';
import naverMImg from '../asset/img/linktodata_m_naver_img.jpg';
import kakaobankMImg from '../asset/img/linktodata_m_kakaobank_img.jpg';

import antImg from '../asset/img/main_taxresult_ant_img.svg';
import pigImg from '../asset/img/main_taxresult_pig_img.svg';

import MainHeader from '../components/header/MainHeader';
import DetailHeader from '../components/header/DetailHeader';
import ProgressHeader from '../components/header/ProgressHeader';
import DeductionHeader from '../components/header/DeductionHeader';
import WithoutXHeader from '../components/header/WithoutXHeader';

export const TARGET_YEAR = 2025;
export const TARGET_YEAR_API = 'YA2025';

//헤더 컴포넌트(페이지별로 어떤 header 사용하는지)
//MainHeader : 메인 , DetailHeader : 상세보기 , ProgressHeader : 전직장~ , DeductionHeader : 공제항목선택
export const getPathList = t => ({
  '/': {
    component: <MainHeader />,
    title: t('header.title1'),
  },
  '/myInfo': {
    component: <DetailHeader />,
    title: t('header.title2'),
  },
  '/terms': {
    component: <WithoutXHeader />,
    title: t('header.title13'),
  },
  '/previousEmployment': {
    component: <ProgressHeader />,
    title: t('header.title3'),
    isPageNavigation: true,
    prevPath: '/',
    nextPath: '/dependents',
  },
  '/previousEmployment/detail': {
    component: <DetailHeader />,
    title: t('header.title4'),
  },
  '/dependents': {
    component: <ProgressHeader />,
    title: t('header.title5'),
    isPageNavigation: true,
    prevPath: '/previousEmployment',
    nextPath: '/eDocuments',
  },
  '/dependents/add': {
    component: <DetailHeader />,
    title: t('header.title6'),
  },
  '/dependents/edit': {
    component: <DetailHeader />,
    title: t('header.title6'),
  },
  '/eDocuments': {
    component: <ProgressHeader />,
    title: t('header.title10'),
    isPageNavigation: true,
    prevPath: '/dependents',
    nextPath: '/deductions/itemSelection',
  },

  '/evidenceDocuments': {
    component: <ProgressHeader />,
    title: t('header.title8'),
    isPageNavigation: true,
    prevPath: '/deductions/itemSelection',
    nextPath: '/resultQuery',
  },
  '/resultQuery': {
    component: <ProgressHeader />,
    title: t('header.title9'),
    isPageNavigation: true,
    prevPath: '/evidenceDocuments',
    nextPath: '/',
  },

  // ... 공통 패턴을 가진 deductions 관련 라우트들
  ...Object.fromEntries(
    deductionPaths.map((item, index) => [
      `/deductions/${item.path}`,
      {
        component: (
          <>
            <ProgressHeader />
            <DeductionHeader />
          </>
        ),
        title: t('header.title7'),
        isPageNavigation: true,
        prevPath: index === 0 ? '/eDocuments' : `/deductions/${deductionPaths[index - 1].path}`,
        nextPath: item.nextPath,
      },
    ]),
  ),
  // detail 페이지들 (상세보기)
  ...Object.fromEntries(
    ['insurancePremiums', 'educationExpenses', 'housingFunds'].map(path => [
      `/deductions/${path}/detail`,
      {
        component: <DetailHeader />,
        title: t('header.title4'),
      },
    ]),
  ),

  // 주택자금 checkList 페이지들
  ...Object.fromEntries(
    ['checkList1', 'checkList2', 'checkList3', 'checkList4'].map(path => [
      `/deductions/housingFunds/${path}`,
      {
        component: <DetailHeader />,
        title: t('detail.title2'),
      },
    ]),
  ),

  // 항목추가 페이지들
  ...Object.fromEntries(
    ['medicalExpenses', 'donations'].map(path => [
      `/deductions/${path}/detail`,
      {
        component: <DetailHeader />,
        title: t('detail.title1'),
      },
    ]),
  ),

  // 주택자금 상세입력 페이지들
  ...Object.fromEntries(
    ['type1', 'type2', 'type3', 'type4'].map(path => [
      `/deductions/housingFunds/detail/${path}`,
      {
        component: <DetailHeader />,
        title: t('detail.title1'),
      },
    ]),
  ),

  // 기타 상세입력 페이지들
  ...Object.fromEntries(
    ['type1', 'type2', 'type3', 'type4', 'type5'].map(path => [
      `/deductions/otherDeductions/detail/${path}`,
      {
        component: <DetailHeader />,
        title: t('detail.title1'),
      },
    ]),
  ),
});

export const detailHeaderTitle = t => {
  return [
    {
      label: t('detail.title4'),
      path: [
        '/deductions/insurancePremiums',
        '/deductions/medicalExpenses',
        '/deductions/educationExpenses',
        '/deductions/donations',
        '/deductions/creditCards',
        '/deductions/housingFunds',
        '/deductions/otherDeductions',
      ],
    },
  ];
};

export const deductionHeaderOptions = t => {
  return [
    { label: t('deduction.title1'), path: '/deductions/itemSelection' }, //함목선택
    { label: t('deduction.title2'), path: '/deductions/insurancePremiums' }, //보험료
    { label: t('deduction.title3'), path: '/deductions/medicalExpenses' }, //의료비
    { label: t('deduction.title4'), path: '/deductions/educationExpenses' }, //교육비
    { label: t('deduction.title5'), path: '/deductions/donations' }, //기부금
    { label: t('deduction.title6'), path: '/deductions/creditCards' }, //신용카드
    { label: t('deduction.title7'), path: '/deductions/housingFunds' }, //주택자금
    { label: t('deduction.title8'), path: '/deductions/otherDeductions' }, //기타
  ];
};

const deductionPaths = [
  { path: 'itemSelection', nextPath: '/deductions/insurancePremiums' },
  { path: 'insurancePremiums', nextPath: '/deductions/medicalExpenses' },
  { path: 'medicalExpenses', nextPath: '/deductions/educationExpenses' },
  { path: 'educationExpenses', nextPath: '/deductions/donations' },
  { path: 'donations', nextPath: '/deductions/creditCards' },
  { path: 'creditCards', nextPath: '/deductions/housingFunds' },
  { path: 'housingFunds', nextPath: '/deductions/otherDeductions' },
  { path: 'otherDeductions', nextPath: '/evidenceDocuments' },
];

//진행 헤더 옵션
export const progressHeaderOptions = t => {
  return [
    {
      //전직장
      label: t('header.title3'),
      checkPath: '/previousEmployment',
      movePath: '/previousEmployment',
    },
    //부양가족
    { label: t('header.title5'), checkPath: '/dependents', movePath: '/dependents' },
    //전자문서
    { label: t('header.title10'), checkPath: '/eDocuments', movePath: '/eDocuments' },
    //공제항목
    { label: t('header.title7'), checkPath: '/deductions', movePath: '/deductions/itemSelection' },
    //증방서류
    { label: t('header.title8'), checkPath: '/evidenceDocuments', movePath: '/evidenceDocuments' },
    //결과조회
    {
      label: t('header.title9'),
      checkPath: '/resultQuery',
      movePath: '/resultQuery',
    },
  ];
};

//햄버거 메뉴리스트
export const menuItems = t => {
  return [
    { label: t('header.title3'), path: '/previousEmployment' }, // 전직장
    { label: t('header.title5'), path: '/dependents' }, // 부양가족
    { label: t('header.title10'), path: '/eDocuments' }, // 전자문서
    { label: t('header.title7'), path: '/subItem' }, // 공제항목
    {
      label: t('deduction.title1'),
      path: '/deductions/itemSelection',
      isSubItem: true,
      isFirst: true,
    }, // 항목선택
    {
      label: t('deduction.title2'),
      path: '/deductions/insurancePremiums',
      isSubItem: true,
    }, // 보험료
    {
      label: t('deduction.title3'),
      path: '/deductions/medicalExpenses',
      isSubItem: true,
    }, // 의료비
    {
      label: t('deduction.title4'),
      path: '/deductions/educationExpenses',
      isSubItem: true,
    }, // 교육비
    {
      label: t('deduction.title5'),
      path: '/deductions/donations',
      isSubItem: true,
    }, // 기부금
    {
      label: t('deduction.title6'),
      path: '/deductions/creditCards',
      isSubItem: true,
    }, // 신용카드
    {
      label: t('deduction.title7'),
      path: '/deductions/housingFunds',
      isSubItem: true,
    }, // 주택자금
    {
      label: t('deduction.title8'),
      path: '/deductions/otherDeductions',
      isSubItem: true,
    }, // 기타
    { label: t('header.title8'), path: '/evidenceDocuments' }, // 증빙서류
    { label: t('header.title9'), path: '/resultQuery' }, // 결과조회
  ];
};

// 부양가족 항목
export const dependentsOptions = t => {
  return [
    { label: t('selectList.title0'), key: 'htm074' }, // 소득금액 100만원 이하
    { label: t('selectList.title1'), key: 'htm003' }, // 기본공제
    {
      label: t('selectList.title2'), // 세대주
      key: 'htm040',
      optionKey: 'htm040',
      option: [
        { label: t('selectList.description7'), value: '1' }, // 세대주
        { label: t('selectList.description8'), value: '3' }, // 세대주의 배우자
      ],
    },
    { label: t('selectList.title10'), key: 'htm032' }, // 외국인
    // { label: t('selectList.title4'), key: 'htm041' }, // 기초수급
    { label: t('selectList.title5'), key: 'htm005' }, // 부녀자
    { label: t('selectList.title6'), key: 'htm080' }, // 한부모
    {
      label: t('selectList.title7'),
      key: 'htm008',
      optionKey: 'htm109',
      option: [
        { label: t('selectList.description4'), value: '1' }, // 첫째
        { label: t('selectList.description5'), value: '2' }, // 둘째
        { label: t('selectList.description6'), value: '3' }, // 셋째이상
      ],
    }, // 출생
    {
      label: t('selectList.title8'),
      key: 'htm058',
      optionKey: 'htm109',
      option: [
        { label: t('selectList.description4'), value: '1' }, // 첫째
        { label: t('selectList.description5'), value: '2' }, // 둘째
        { label: t('selectList.description6'), value: '3' }, // 셋째이상
      ],
    }, // 입양
    { label: t('selectList.title9'), key: 'htm039' }, // 경로우대
    {
      label: t('selectList.title3'), // 장애인
      key: 'htm004',
      optionKey: 'htm081',
      option: [
        { label: t('selectList.description1'), value: '1' }, // [장애인복지법]에 의한 장애인
        { label: t('selectList.description2'), value: '2' }, // [국가유공자 등 예우 및 지원에 관한 법률]에 의한 상이자 및 이와 유사한 자로서 근로능력이 없는 자
        { label: t('selectList.description3'), value: '3' }, // 항시 치료를 요하는 중증 환자(의료기관에서 발급한 장애인 증명서 필요)
      ],
    },
    { label: t('selectList.title11'), key: 'htm158' }, // 결혼(25년 중 혼인신고)
  ];
};

//부양가족 관계 선택
export const relationOptions = t => {
  return [
    { label: t('add.relationOption.option0'), value: '' }, // 관계선택
    { label: t('add.relationOption.option1'), value: '0', isDisabled: true }, // 본인
    { label: t('add.relationOption.option2'), value: '3' }, // 배우자
    { label: t('add.relationOption.option3'), value: '1' }, // 소득자 직계존속
    { label: t('add.relationOption.option4'), value: '2' }, // 배우자 직계존속
    { label: t('add.relationOption.option5'), value: '4' }, // 직계비속
    { label: t('add.relationOption.option6'), value: '5' }, // 형제자매
    { label: t('add.relationOption.option7'), value: '6' }, // 위탁아동
  ];
};

//부양가족 관계 선택
export const relationHtm002Options = t => {
  return [
    { label: t('add.relationOption.option0'), value: '' }, // 관계선택
    { label: t('add.relationOption.option8'), value: '1' }, // 자녀
    { label: t('add.relationOption.option9'), value: '2' }, // 손자/손녀
    { label: t('add.relationOption.option10'), value: '3' }, // 사위
    { label: t('add.relationOption.option11'), value: '4' }, // 며느리
  ];
};

//전자문서택- 주택자금 공제 체크리스트
export const eDocumentHousingFundsCheckList = t => {
  return [
    {
      title: t('card.itemTitle1'),
      path: '/deductions/housingFunds/checkList1',
      key: 'htm102',
      status: '',
    },
    {
      title: t('card.itemTitle2'),
      path: '/deductions/housingFunds/checkList2',
      key: 'htm103',
      status: '1',
    },
    {
      title: t('card.itemTitle3'),
      path: '/deductions/housingFunds/checkList3',
      key: 'htm104',
      status: '2',
    },
    {
      title: t('card.itemTitle4'),
      path: '/deductions/housingFunds/checkList4',
      key: 'htm105',
      status: '1',
    },
  ];
};

export const eDocumentErrorMessages = t => {
  return [
    { label: t('uploadPdf.errorMessages.001'), key: '001' }, // 잘못된 파일 형식
    { label: t('uploadPdf.errorMessages.002'), key: '002' }, // 위변조 검증 실패
    { label: t('uploadPdf.errorMessages.003'), key: '003' }, // 통합파일 확인 필요
    { label: t('uploadPdf.errorMessages.004'), key: '004' }, // 상세파일 확인 필요
    { label: t('uploadPdf.errorMessages.011'), key: '011' }, // 중복된 파일
    { label: t('uploadPdf.errorMessages.201'), key: ['201', '202'] }, // 필요없는 파일
    { label: t('uploadPdf.errorMessages.012'), key: '012' }, // 일괄제공서비스 이용회사
    { label: t('uploadPdf.errorMessages.013'), key: '013' }, // 암호가 설정된 파일
    { label: t('uploadPdf.errorMessages.014'), key: '014' }, // 당해년도 파일이 아님
    { label: t('uploadPdf.errorMessages.015'), key: '015' }, // 예외 처리
    { label: t('uploadPdf.errorMessages.default'), key: 'default' }, // 알 수 없는 오류
  ];
};

// 공제항목선택
export const itemSelectionOptions = t => {
  return [
    { label: t('itemSelectionOptions.option0'), key: 'htm074' }, // 소득요건
    { label: t('itemSelectionOptions.option1'), key: 'htm003' }, // 기본공제
    { label: t('itemSelectionOptions.option2'), key: 'htm010' }, // 의료비
    { label: t('itemSelectionOptions.option3'), key: 'htm009' }, // 보험료
    { label: t('itemSelectionOptions.option4'), key: 'htm011' }, // 교육비
    { label: t('itemSelectionOptions.option5'), key: 'htm014' }, // 기부금
    { label: t('itemSelectionOptions.option6'), key: 'htm012' }, // 신용카드
    { label: t('itemSelectionOptions.option7'), key: 'htm061' }, // 주택자금
    { label: t('itemSelectionOptions.option8'), key: 'htm062' }, // 연금
  ];
};

// 보험료 input
export const insuranceDetailInputList = t => {
  return [
    { label: t('detail.inputLabel1'), key: 'htm016', disabled: true }, //국세청
    { label: t('detail.inputLabel2'), key: 'htm017', disabled: true }, //(장애)국세청
    { label: t('detail.inputLabel3'), key: 'htm018' }, //국세청외
    { label: t('detail.inputLabel4'), key: 'htm019' }, //(장애)국세청외
    {
      label: t('detail.inputLabel5'),
      key: 'total',
      color: 'secondary',
      variant: 'contained',
      disabled: true,
    },
  ];
};

//관계 객체
export const RELATION_MAP = {
  0: 'relation.item0', // 본인
  1: 'relation.item2', // 소득자 직계존속
  2: 'relation.item3', // 배우자 직계존속
  3: 'relation.item1', // 배우자
  4: 'relation.item4', // 직계비속
  5: 'relation.item5', // 형제자매
  6: 'relation.item6', // 위탁아동
};

export const FILE_MAP = {
  0: 'file.item0', // 부양가족
  1: 'file.item1', // 보험료
  2: 'file.item2', // 의료비
  3: 'file.item3', // 교육비
  4: 'file.item4', // 기부금
  5: 'file.item5', // 신용카드
  6: 'file.item6', // 주택자금
  7: 'file.item7', // 기타
};

// 의료비 input
export const medicalDetailInputList = t => {
  return [
    {
      //증빙코드
      title: t('detail.title1'),
      label: t('detail.inputLabel1'),
      key: 'htm006',
      input: 'selectBox',
      variant: 'contained',
    },
    //지급처
    { title: t('detail.title1'), label: t('detail.inputLabel2'), key: 'htm001' },
    //사업자번호
    { title: t('detail.title1'), label: t('detail.inputLabel3'), key: 'htm002' },
    //건수
    { title: t('detail.title1'), label: t('detail.inputLabel4'), key: 'htm007', isNumber: true },
    //금액
    { title: t('detail.title1'), label: t('detail.inputLabel5'), key: 'htm016', isNumber: true },
    // { title: t('detail.title2'), label: t('detail.inputLabel6'), key: 'htm006' },
    // { title: t('detail.title2'), label: t('detail.inputLabel7'), key: 'htm007' },
  ];
};

export const medicalCodeOptions = t => {
  return [
    { label: t('detail.medicalCode.option0'), value: '' }, // 선택하세요
    { label: t('detail.medicalCode.option1'), value: '1' }, // 국세청자료(안경점제외)
    { label: t('detail.medicalCode.option2'), value: '2' }, // 건강보험공단
    { label: t('detail.medicalCode.option3'), value: '3' }, // 진료, 약제비
    { label: t('detail.medicalCode.option4'), value: '4' }, // 장기요양급여비용
    { label: t('detail.medicalCode.option5'), value: '5' }, // 기타의료비영수증
    { label: t('detail.medicalCode.option6'), value: '6' }, // 안경점 국세청
    { label: t('detail.medicalCode.option7'), value: '7' }, // 안경점 국세청외
    { label: t('detail.medicalCode.option8'), value: '8' }, // 난임시술비
    { label: t('detail.medicalCode.option9'), value: '9' }, // 산후조리원 국세청
    { label: t('detail.medicalCode.option10'), value: '10' }, // 산후조리원 국세청 외
    // { label: t('medicalCode.option11'), value: '11' }, // 미숙아·선천성 이상아 국세청
    { label: t('detail.medicalCode.option12'), value: '12' }, // 미숙아·선천성 이상아 국세청외
  ];
};

// 교육비 input
export const educationDetailInputList = t => {
  return [
    {
      label: t('detail.inputLabel1'),
      key: 'htm015',
      input: 'selectBox',
      variant: 'contained',
    },
    { label: t('detail.inputLabel2'), key: 'htm023', isNumber: true, isDisabled: true }, //국세청 - 일반
    { label: t('detail.inputLabel3'), key: 'htm072', isNumber: true, isDisabled: true }, //국세청 - 교복비
    { label: t('detail.inputLabel5'), key: 'htm110', isNumber: true, isDisabled: true }, //국세청 - 현장학습비
    { label: t('detail.inputLabel6'), key: 'htm024', isNumber: true }, //국세청외 - 일반
    { label: t('detail.inputLabel7'), key: 'htm073', isNumber: true }, //국세청외 - 교복비
    { label: t('detail.inputLabel8'), key: 'htm111', isNumber: true }, //국세청외 - 현장학습비
    { label: t('detail.inputLabel9'), key: 'htm151', isNumber: true }, //공제제외금액
  ];
};

export const educationCodeOptions = t => {
  return [
    { label: t('detail.educationCode.option0'), value: '' }, // 선택하세요
    { label: t('detail.educationCode.option1'), value: '1' }, // 대학원(전액)
    { label: t('detail.educationCode.option2'), value: '2' }, // 대학교(전액)
    { label: t('detail.educationCode.option3'), value: '3' }, // 초, 중, 고(전액)
    { label: t('detail.educationCode.option4'), value: '4' }, // 직업능력개발훈련(전액)
    { label: t('detail.educationCode.option5'), value: '5' }, // 장애인특수교육비(전액)
    { label: t('detail.educationCode.option6'), value: '6' }, // 취학전(전액)
    { label: t('detail.educationCode.option7'), value: '7' }, // 학자금대출(전액)
  ];
};

//본인외
export const educationCodeOptions02 = t => {
  return [
    { label: t('detail.educationCode.option0'), value: '' }, // 선택하세요
    // { label: t('detail.educationCode.option1'), value: '1' }, // 대학원(전액)
    { label: t('detail.educationCode.option8'), value: '2' }, // 대학교(1인 900만원)
    { label: t('detail.educationCode.option9'), value: '3' }, // 초, 중, 고(1인 300만원)
    // { label: t('detail.educationCode.option4'), value: '4' }, // 직업능력개발훈련(전액)
    { label: t('detail.educationCode.option5'), value: '5' }, // 장애인특수교육비(전액)
    { label: t('detail.educationCode.option10'), value: '6' }, // 취학전(전액)
    // { label: t('detail.educationCode.option7'), value: '7' }, // 학자금대출(전액)
  ];
};

// 기부금 input
export const donationDetailInputList = t => {
  return [
    {
      label: t('detail.inputLabel1'),
      key: 'htm016',
      input: 'selectBox',
      variant: 'contained',
    },
    {
      label: t('detail.inputLabel2'),
      key: 'htm005',
      input: 'selectBox',
      variant: 'contained',
    },
    { label: t('detail.inputLabel3'), key: 'htm002' }, // 상호
    { label: t('detail.inputLabel4'), key: 'htm001' }, // 사업자번호
    { label: t('detail.inputLabel5'), key: 'htm003' }, // 기부내용
    { label: t('detail.inputLabel6'), key: 'htm008', isDate: true }, // 기부일
    { label: t('detail.inputLabel7'), key: 'htm006', isNumber: true }, // 건수
    { label: t('detail.inputLabel8'), key: 'htm009' }, // 일련번호
    { label: t('detail.inputLabel9'), key: 'htm007', isNumber: true }, // 금액
    { label: t('detail.inputLabel12'), key: 'htm031', isNumber: true }, // 기부장려금
    { label: t('detail.inputLabel10'), key: 'htm027', isNumber: true }, // 전년도 공제액
    { label: t('detail.inputLabel11'), key: 'htm028', isNumber: true }, // 이월된 기부금
  ];
};

// 기부금 국세청 구분 옵션
export const donationNtsTypeOptions = t => {
  return [
    { label: t('detail.ntsType.option0'), value: '' }, // 선택하세요
    { label: t('detail.ntsType.option1'), value: '1' }, // 국세청
    { label: t('detail.ntsType.option2'), value: '2' }, // 국세청외
    { label: t('detail.ntsType.option3'), value: '3' }, // 국세청외일괄
    { label: t('detail.ntsType.option4'), value: '4' }, // 자동이월국세청
    { label: t('detail.ntsType.option5'), value: '5' }, // 자동이월국세청외
  ];
};

// 기부금 국세청 구분 옵션 --국세청외만 선택하게 바꿈
export const donationNtsTypeOptions02 = t => {
  return [
    // { label: t('detail.ntsType.option0'), value: '' }, // 선택하세요
    // { label: t('detail.ntsType.option1'), value: '1' }, // 국세청
    { label: t('detail.ntsType.option2'), value: '2' }, // 국세청외
    // { label: t('detail.ntsType.option3'), value: '3' }, // 국세청외일괄
    // { label: t('detail.ntsType.option4'), value: '4' }, // 자동이월국세청
    // { label: t('detail.ntsType.option5'), value: '5' }, // 자동이월국세청외
  ];
};

// 기부금 구분 코드 옵션
export const donationTypeOptions = t => {
  return [
    { label: t('detail.donationType.option0'), value: '' }, // 선택하세요
    { label: t('detail.donationType.option1'), value: '20' }, // 정치자금기부금
    { label: t('detail.donationType.option2'), value: '10' }, // 특례기부금
    { label: t('detail.donationType.option3'), value: '42' }, // 우리사주조합기부금
    { label: t('detail.donationType.option4'), value: '41' }, // 종교단체기부금
    { label: t('detail.donationType.option5'), value: '40' }, // 지정기부금
    { label: t('detail.donationType.option6'), value: '43' }, // 고향사랑기부금
    { label: t('detail.donationType.option7'), value: '44' }, // 고향사랑기부금(특별재난지역)
  ];
};

// 기부금 구분 코드 옵션 --본인제외
export const donationTypeOptions02 = t => {
  return [
    { label: t('detail.donationType.option0'), value: '' }, // 선택하세요
    // { label: t('detail.donationType.option1'), value: '20' }, // 정치자금기부금
    { label: t('detail.donationType.option2'), value: '10' }, // 특례기부금
    // { label: t('detail.donationType.option3'), value: '42' }, // 우리사주조합기부금
    { label: t('detail.donationType.option4'), value: '41' }, // 종교단체기부금
    { label: t('detail.donationType.option5'), value: '40' }, // 지정기부금
    // { label: t('detail.donationType.option6'), value: '43' }, // 고향사랑기부금
  ];
};

// 주택자금 공제 체크리스트
export const housingFundsCheckList = t => {
  return [
    {
      title: t('card.itemTitle1'),
      path: '/deductions/housingFunds/checkList1',
      openType: 'type1',
      key: 'htm102', //주택임차차입금
    },
    {
      title: t('card.itemTitle2'),
      path: '/deductions/housingFunds/checkList2',
      openType: 'type2',
      key: 'htm103', //장기주택
    },
    {
      title: t('card.itemTitle3'),
      path: '/deductions/housingFunds/checkList3',
      openType: 'type3',
      key: 'htm104', //주택마련
    },
    {
      title: t('card.itemTitle4'),
      path: '/deductions/housingFunds/checkList4',
      openType: 'type4',
      key: 'htm105', //월세액
    },
  ];
};

// 주택자금 입력 리스트
export const housingFundsInputList = t => {
  return [
    {
      //국세청
      label: t('typeItem.item1'),
      key: 'htm085',
      disabled: true,
    },
    {
      //국세청 외
      label: t('typeItem.item2'),
      key: 'htm086',
    },
    {
      //합계
      label: t('typeItem.item3'),
      key: 'total',
      color: 'secondary',
      variant: 'contained',
    },
    {
      //거주자 국세청 외 -
      label: t('typeItem.item2'),
      key: 'htm078',
    },
    {
      //거주자 합계 // 25.01.14 PC랑 동일하게 맞추려고 총합계가아닌 거주자 합계를 추가함 선희
      label: t('typeItem.item3'),
      key: 'total',
      color: 'secondary',
      variant: 'contained',
    },
  ];
};

// 장기주택저당차입금 2011년 이전 차입분 입력 리스트
export const getMortgage2011List = t => ({
  title: t('typeItem.type2.title1'),
  year: '2011',
  items: [
    {
      label: t('typeItem.type2.item1'), //15년 미만상환
      year: '2011',
      index: 1,
      key: ['htm079', 'htm082'], //국세청, 국세청외
    },
    {
      label: t('typeItem.type2.item2'), // 15년~29년 상환
      year: '2011',
      index: 2,
      key: ['htm080', 'htm083'],
    },
    {
      label: t('typeItem.type2.item3'), //30년 이상 상환
      year: '2011',
      index: 3,
      key: ['htm081', 'htm084'],
    },
    {
      label: t('typeItem.type2.item6'), // 고정금리이면서, 비거치상환 대출
      year: '2011',
      index: 4,
      key: ['htm093', 'htm095'],
    },
    {
      label: t('typeItem.type2.item7'), // 고정금리이거나, 비거치상환 대출
      year: '2011',
      index: 5,
      key: ['htm092', 'htm094', 'total'],
    },
  ],
});

// 장기주택저당차입금 2012년 이후 차입분 입력 리스트
export const getMortgage2012List = t => ({
  title: t('typeItem.type2.title2'),

  items: [
    {
      label: t('typeItem.type2.item6'), // 고정금리이면서, 비거치상환 대출
      year: '2012',
      index: 4,
      key: ['htm163', 'htm167'],
    },
    {
      label: t('typeItem.type2.item7'), // 고정금리이거나, 비거치상환 대출
      year: '2012',
      index: 5,
      key: ['htm164', 'htm168'],
    },
    {
      label: t('typeItem.type2.item5'), //그 외
      year: '2012',
      index: 2,
      key: ['htm165', 'htm169'],
    },
    {
      label: t('typeItem.type2.item9'), // 고정금리이거나, 비거치상환 대출(10년~15년)
      year: '2012',
      index: 1,
      key: ['htm166', 'htm170', 'total'],
    },
  ],
});

// 장기주택저당차입금 2015년 이후 차입분 입력 리스트
export const getMortgage2015List = t => ({
  title: t('typeItem.type2.title3'),
  items: [
    { label: t('typeItem.type2.item6'), year: '2015', index: 1, key: ['htm163', 'htm167'] },
    { label: t('typeItem.type2.item7'), year: '2015', index: 2, key: ['htm164', 'htm168'] },
    { label: t('typeItem.type2.item8'), year: '2015', index: 3, key: ['htm165', 'htm169'] },
    {
      label: t('typeItem.type2.item9'),
      year: '2015',
      index: 4,
      key: ['htm166', 'htm170', 'total'],
    },
  ],
});

// 주택마련저축 입력 리스트
export const getSavingsInputFields = t => [
  {
    label: t('detail.type3.inputLabel1'),
    key: 'htmKFlag', //국세청구분
  },
  {
    label: t('detail.type3.inputLabel2'),
    key: 'htm001', //저축구분
  },
  {
    label: t('detail.type3.inputLabel3'),
    key: 'htm002', //금융기관
  },
  {
    label: t('detail.type3.inputLabel4'),
    key: 'htm003',
  },
  {
    label: t('detail.type3.inputLabel5'),
    key: 'htm004',
    isNumber: true,
  },
];

// 월세액 입력 리스트
export const getRentInputFields = t => [
  {
    label: t('detail.type4.inputLabel1'),
    key: 'htmKFlag',
  },
  {
    label: t('detail.type4.inputLabel2'),
    key: 'htm013',
    endKey: 'htm014',
  },
  {
    label: t('detail.type4.inputLabel3'),
    key: 'htm001',
    isNumber: true,
  },
  {
    label: t('detail.type4.inputLabel4'),
    key: 'htm011',
    endKey: 'htm012',
  },
  {
    label: t('detail.type4.inputLabel5'),
    key: 'htm016',
  },
  {
    label: t('detail.type4.inputLabel6'),
    key: 'htm017',
  },
  {
    label: t('detail.type4.inputLabel7'),
    key: 'htm004',
  },
  {
    label: t('detail.type4.inputLabel8'),
    key: 'htm005',
  },
  {
    label: t('detail.type4.inputLabel9'),
    key: 'htm018',
  },
];

//detail
// 주택임차차입금 상세 입력 리스트
export const housingFundsDetailInputList1 = t => {
  return [
    {
      label: `${t('detail.typeItem1')}-${t('detail.type1.inputLabel1')}`,
      key: 'htm085', //국세청
      disabled: true,
      variant: 'contained',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type1.inputLabel1')}`,
      key: 'htm086', //국세청외 - 대출기간차입
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type1.inputLabel2')}`,
      key: 'htm078', //국세청외 - 원리금상환액
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type1.inputLabel3')}`,
      key: 'htm117', //국세청외 - 원리금상환액 이자
    },
  ];
};

// 주택자금 공제 상세 입력 리스트(장기주택저당차입금)
export const housingFundsDetailInputList2 = t => {
  return [
    //2011년 이전 차입분 국세청
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel1')}`,
      message: t('detail.type2.inputMessage1'),
      key: 'htm079',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel2')}`,
      message: t('detail.type2.inputMessage2'),
      key: 'htm080',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel3')}`,
      message: t('detail.type2.inputMessage3'),
      key: 'htm081',
      disabled: true,
    },
    //2011년 이전 차입분 국세청외
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel1')}`,
      message: t('detail.type2.inputMessage1'),
      key: 'htm082',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel2')}`,
      message: t('detail.type2.inputMessage2'),
      key: 'htm083',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel3')}`,
      message: t('detail.type2.inputMessage3'),
      key: 'htm084',
    },
    // 2012년 이후 차입분
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel1')}`,
      message: t('detail.type2.inputMessage1'),
      key: 'htm092',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel4')}`,
      message: t('detail.type2.inputMessage2'),
      key: 'htm093',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel1')}`,
      message: t('detail.type2.inputMessage1'),
      key: 'htm094',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel4')}`,
      key: 'htm095',
    },
    // 2015년 이후 차입분 -국세청 (15년이상)
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel5')}`,
      message: t('detail.type2.inputMessage4'),
      key: 'htm163',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel6')}`,
      message: t('detail.type2.inputMessage4'),
      key: 'htm164',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel7')}`,
      key: 'htm165',
      disabled: true,
    },
    {
      label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel6')}`,
      message: t('detail.type2.inputMessage5'),
      key: 'htm166',
      disabled: true,
    },
    //------↑여기까지 국세청
    //------↓여기부터 국세청외
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel5')}`,
      message: t('detail.type2.inputMessage6'),
      key: 'htm167',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel6')}`,
      message: t('detail.type2.inputMessage6'),
      key: 'htm168',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel7')}`,
      message: t('detail.type2.inputMessage6'),
      key: 'htm169',
    },
    {
      label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel6')}`,
      message: t('detail.type2.inputMessage7'),
      key: 'htm170',
    },
  ];
};

export const housingFundsDetailInputList2_2011 = t => [
  //2011년 이전 차입분 국세청
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel1')}`, //국세청-장기주택저당차입금(600)
    message: t('detail.type2.inputMessage1'), //15년 미만 상환(2003.12.31 이전)
    key: 'htm079',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel2')}`, //국세청-장기주택저당차입금(1000)
    message: t('detail.type2.inputMessage2'), //15년~29년 상환(2004.1.1 이후)
    key: 'htm080',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel3')}`, //국세청-장기주택저당차입금(1500)
    message: t('detail.type2.inputMessage3'), //30년 이상 상환
    key: 'htm081',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel5')}`, //국세청-고정금리이면서, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm093',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel6')}`, //국세청-고정금리이거나, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm092',
    disabled: true,
  },
  //2011년 이전 차입분 국세청외
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel1')}`, //국세청외-장기주택저당차입금(600)
    message: t('detail.type2.inputMessage1'), //15년 미만 상환(2003.12.31 이전)
    key: 'htm082',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel2')}`, //국세청외-장기주택저당차입금(1000)
    message: t('detail.type2.inputMessage2'), //15년~29년 상환(2004.1.1 이후)
    key: 'htm083',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel3')}`, //국세청외-장기주택저당차입금(1500)
    message: t('detail.type2.inputMessage3'), //30년 이상 상환
    key: 'htm084',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel5')}`, //국세청외-고정금리이면서, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm095',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel6')}`, //국세청-고정금리이거나, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm094',
  },
];

export const housingFundsDetailInputList2_2012 = t => [
  // 2012년 이후 차입분
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel5')}`, //국세청-고정금리이면서, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm163',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel6')}`, //국세청-고정금리이거나, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm164',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel4')}`, //국세청-그 외(1000)
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm165',
    disabled: true,
  },
  {
    label: `${t('detail.typeItem1')}-${t('detail.type2.inputLabel6')}`, //국세청-고정금리이거나, 비거치상환 대출
    message: t('detail.type2.inputMessage5'), //10년~15년
    key: 'htm166',
    disabled: true,
  },
  //국세청외
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel5')}`, //국세청외-고정금리이면서, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm167',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel6')}`, //국세청외-고정금리이거나, 비거치상환 대출
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm168',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel4')}`, //국세청외-그 외(1000)
    message: t('detail.type2.inputMessage4'), //15년이상
    key: 'htm169',
  },
  {
    label: `${t('detail.typeItem2')}-${t('detail.type2.inputLabel6')}`, //국세청외-고정금리이거나, 비거치상환 대출
    message: t('detail.type2.inputMessage5'), //10년~15년
    key: 'htm170',
  },
];

//주택마련저축 상세입력리스트
export const housingSavingsDetailInputList3 = t => {
  return [
    {
      label: t('detail.type3.inputLabel1'),
      key: 'htmKFlag',
      input: 'selectBox',
    },
    {
      label: t('detail.type3.inputLabel2'),
      key: 'htm001',
      input: 'selectBox',
    },
    {
      label: t('detail.type3.inputLabel3'),
      key: 'htm002',
      input: 'selectBox',
    },
    {
      label: t('detail.type3.inputLabel4'),
      key: 'htm003',
    },
    {
      label: t('detail.type3.inputLabel5'),
      key: 'htm004', //납입금액
      isNumber: true,
    },
  ];
};

//주택마련저축 저축구분 옵션
export const savingCategoryOptions = t => {
  return [
    { label: t('detail.type3.savingCategoryOptions.option0'), value: '' }, // 선택하세요
    { label: t('detail.type3.savingCategoryOptions.option1'), value: '1' }, // 청약저축
    { label: t('detail.type3.savingCategoryOptions.option2'), value: '3' }, // 주택청약종합저축
    { label: t('detail.type3.savingCategoryOptions.option3'), value: '4' }, // 근로자주택마련저축
  ];
};

//주택마련저축 국세청 구분
export const ntsTypeOptions = t => {
  return [
    { label: t('ntsOptionList.item1'), value: '' }, // 선택하세요
    { label: t('ntsOptionList.item2'), value: '1' }, // 국세청
    { label: t('ntsOptionList.item3'), value: '2' }, // 국세청외
  ];
};

// 월세액 상세입력리스트
export const housingFundsDetailInputList4 = t => {
  return [
    {
      label: t('detail.type4.inputLabel1'),
      key: 'htmKFlag',
      input: 'selectBox',
    },
    {
      label: t('detail.type4.inputLabel2'),
      key: 'htm013', //근무기간,
      endKey: 'htm014',
      isDate: true,
    },
    {
      label: t('detail.type4.inputLabel3'),
      key: 'htm001', //월세액
      isNumber: true,
    },
    {
      label: t('detail.type4.inputLabel4'),
      key: 'htm011', //임차기간
      endKey: 'htm012',
      isDate: true,
    },
    {
      label: t('detail.type4.inputLabel5'),
      key: 'htm016', //임대인성명
    },
    {
      label: t('detail.type4.inputLabel6'),
      key: 'htm017', //임대인 주민(사업자)
    },
    {
      label: t('detail.type4.inputLabel7'),
      key: 'htm004', //주택유형
      input: 'selectBox',
    },
    {
      label: t('detail.type4.inputLabel8'),
      key: 'htm005', //면적
      isNumber: true,
    },
    {
      label: t('detail.type4.inputLabel9'),
      key: 'htm018', //임대차계약서주소지
    },
  ];
};

//월세액 주택유형 옵션
export const housingFundsTypeOptions = t => {
  return [
    { label: t('detail.type4.codeList.option0'), value: '' }, // 선택하세요
    { label: t('detail.type4.codeList.option1'), value: '1' }, // 단독주택
    { label: t('detail.type4.codeList.option2'), value: '2' }, // 다가구
    { label: t('detail.type4.codeList.option3'), value: '3' }, // 다세대주택
    { label: t('detail.type4.codeList.option4'), value: '4' }, // 연립주택
    { label: t('detail.type4.codeList.option5'), value: '5' }, // 아파트
    { label: t('detail.type4.codeList.option6'), value: '6' }, // 오피스텔
    { label: t('detail.type4.codeList.option7'), value: '7' }, // 고시원
    { label: t('detail.type4.codeList.option8'), value: '8' }, // 기타
  ];
};

//기타 - 연금저축 상세입력리스트
export const otherDeductionsDetailInputList1 = t => {
  return [
    {
      label: t('detail.type1.inputLabel1'),
      key: 'htmKFlag', //국세청구분
      input: 'selectBox',
      options: [
        { label: t('detail.type1.optionList1.default'), value: '' },
        { label: t('detail.type1.optionList1.item1'), value: '1' },
        { label: t('detail.type1.optionList1.item2'), value: '2' },
      ],
    },
    {
      label: t('detail.type1.inputLabel2'),
      key: 'htm001', //저축구분
      input: 'selectBox',
      options: [
        { label: t('detail.type1.optionList2.default'), value: '' },
        { label: t('detail.type1.optionList2.item1'), value: '1' }, //개인연금저축
        { label: t('detail.type1.optionList2.item2'), value: '2' }, //연금저축
        { label: t('detail.type1.optionList2.item3'), value: '3' }, //퇴직연금
        { label: t('detail.type1.optionList2.item4'), value: '4' }, //과학기술인공제회
        // { label: t('detail.type1.optionList2.item5'), value: '5' }, //지역연금
        { label: t('detail.type1.optionList2.item6'), value: '6' }, //확정기여형퇴직연금
        { label: t('detail.type1.optionList2.item7'), value: '8' }, //ISA계좌 개인연금
        { label: t('detail.type1.optionList2.item8'), value: '9' }, //ISA계좌 퇴직연금
      ],
    },
    {
      label: t('detail.type1.inputLabel3'),
      key: 'htm002', //금융기관
      input: 'selectBox',
      options: [],
    },
    {
      label: t('detail.type1.inputLabel4'),
      key: 'htm003', //계좌번호
    },
    {
      label: t('detail.type1.inputLabel5'),
      key: 'htm004', //납입금액
      isNumber: true,
    },
    {
      label: t('detail.type1.inputLabel6'),
      key: 'htm010', //ISA 만기전환 납입금액
      isNumber: true,
    },
  ];
};

//기타 - 장기집합투자증권 상세입력리스트
export const otherDeductionsDetailInputList2 = t => {
  return [
    {
      label: t('detail.type2.inputLabel1'),
      key: 'htmKFlag', //국세청
      input: 'selectBox',
      options: [
        { label: t('detail.type2.optionList1.default'), value: '' },
        { label: t('detail.type2.optionList1.item1'), value: '1' },
        { label: t('detail.type2.optionList1.item2'), value: '2' },
      ],
    },
    {
      label: t('detail.type2.inputLabel2'),
      key: 'htmFlag',
      input: 'selectBox',
      options: [
        { label: t('detail.type2.optionList2.default'), value: '' },
        { label: t('detail.type2.optionList2.item1'), value: 'F' }, //장기집합투자
        { label: t('detail.type2.optionList2.item2'), value: 'C' }, //청년형
      ],
    },
    {
      label: t('detail.type2.inputLabel3'),
      key: 'htm002', //금융기관
      input: 'selectBox',
      options: [],
    },
    {
      label: t('detail.type2.inputLabel4'),
      key: 'htm003', //계좌번호
    },
    {
      label: t('detail.type2.inputLabel5'),
      key: 'htm012', //가입날자
      isDate: true,
    },
    {
      label: t('detail.type2.inputLabel6'),
      key: 'htm013', //계약기간월수
      isNumber: false,
    },
    {
      label: t('detail.type2.inputLabel7'),
      key: 'htm004', //납입금액
      isNumber: true,
    },
  ];
};

//기타 - 투자조합 상세입력리스트
export const otherDeductionsDetailInputList3 = t => {
  return [
    {
      label: t('detail.type3.inputLabel1'),
      key: 'htmKFlag', //국세청
      input: 'selectBox',
      options: [
        { label: t('detail.type3.optionList1.default'), value: '' },
        { label: t('detail.type3.optionList1.item1'), value: '1' },
        { label: t('detail.type3.optionList1.item2'), value: '2' },
      ],
    },
    {
      label: t('detail.type3.inputLabel2'),
      input: 'selectBox',
      key: 'htm007', //투자연도
      isDate: true,
      options: [
        { label: t('detail.type3.optionList1.default'), value: '' },
        // { label: '2020', value: '2020' },
        // { label: '2021', value: '2021' },
        // { label: '2022', value: '2022' },
        { label: '2023', value: '2023' },
        { label: '2024', value: '2024' },
        { label: '2025', value: '2025' },
      ],
    },
    {
      label: t('detail.type3.inputLabel3'),
      key: 'htm008', //투자구분
      input: 'selectBox',
      options: [
        { label: t('detail.type3.optionList2.default'), value: '' },
        { label: t('detail.type3.optionList2.item1'), value: '1' },
        { label: t('detail.type3.optionList2.item2'), value: '2' },
        { label: t('detail.type3.optionList2.item3'), value: '3' },
      ],
    },
    {
      label: t('detail.type3.inputLabel4'),
      key: 'htm009', //조합명
    },
    {
      label: t('detail.type3.inputLabel5'),
      key: 'htm003', //계좌번호
    },
    {
      label: t('detail.type3.inputLabel6'),
      key: 'htm004', //
      isNumber: true,
    },
  ];
};

export const htm007Options = t => {
  return [
    { label: t('optionItem1'), value: '' },
    { label: '2020', value: '2020' },
    { label: '2021', value: '2021' },
    { label: '2022', value: '2022' },
    { label: '2023', value: '2023' },
    // { label: '2024', value: '2024' },
  ];
};

//기타 - 우리사주 소기업, 소상공인 상세입력리스트
export const otherDeductionsDetailInputList4 = t => {
  return [
    {
      //2015년 12.31 이전가입자 -국세청
      label: `${t('detail.type4.inputMessage1')} (${t('detail.type4.inputLabel2')})`,
      key: 'htm048',
      isNumber: true,
      disabled: true,
    },
    {
      //2015년 12.31 이전가입자 -국세청외
      label: `${t('detail.type4.inputMessage1')} (${t('detail.type4.inputLabel3')})`,
      key: 'htm053',
      isNumber: true,
    },
    {
      //2016 01 01 이후 가입자 - 국세청
      label: `${t('detail.type4.inputMessage2')} (${t('detail.type4.inputLabel2')})`,
      key: 'htm171',
      isNumber: true,
      disabled: true,
    },
    {
      //2016 01 01 이후 가입자 - 국세청외
      label: `${t('detail.type4.inputMessage2')} (${t('detail.type4.inputLabel3')})`,
      key: 'htm172',
      isNumber: true,
    },
  ];
};

//기타 - 세액공제 상세입력리스트
export const otherDeductionsDetailInputList5 = t => {
  return [
    {
      label: t('detail.type5.inputLabel1'),
      key: 'htm035', //소득세 감면법
      isNumber: true,
    },
    {
      label: t('detail.type5.inputLabel2'),
      key: 'htm036', //조세특례 제한법감면
      isNumber: true,
    },
    {
      label: `${t('detail.type5.inputLabel3')} (${t('detail.type5.inputLabel8')})`,
      key: 'htm055', //주택차입금
      isNumber: true,
    },
    {
      label: t('detail.type5.inputLabel5'),
      key: 'htm124', //외국납부 국외원천소득
      isNumber: true,
    },
    {
      label: t('detail.type5.inputLabel6'),
      key: 'htm125', //외국납부 - 납부세액(그 외)
      isNumber: true,
    },
    {
      label: t('detail.type5.inputLabel7'),
      key: 'htm037', //외국인단일세율
    },
  ];
};

//결과조회 - 카카오톡 인증 개인정보리스트
export const personalInfoInputList = t => {
  return [
    {
      label: t('personalInfo.inputLabel1'),
      key: 'htmInsaPerNm',
      placeholder: '홍길동',
    },
    {
      label: t('personalInfo.inputLabel2'),
      key: 'htmPerBirth',
      placeholder: '19900101',
    },
    {
      label: t('personalInfo.inputLabel3'),
      key: 'htmInsaPerHTel',
      placeholder: '01012345678',
    },
  ];
};

//국세청 연동 - 카카오톡, 토스 선택
export const kakaoTossSelectItem = t => {
  return [
    { label: t('linkToData.step2.kakao'), value: '0', icon: kakao_icon }, //카카오톡
    { label: t('linkToData.step2.toss'), value: '1', icon: toss_icon }, //토스
    { label: t('linkToData.step2.naver'), value: '2', icon: naver_icon }, //네이버
    { label: t('linkToData.step2.kakaobank'), value: '3', icon: kakaobank_icon }, //카카오뱅크
  ];
};

//step3 카카오 토스 설명
export const kakaoTossSelectItem02 = t => {
  return [
    {
      label: t('linkToData.step3.item.kakao'),
      description: t('linkToData.step3.item.description'),
      img: kakaoMImg,
    }, //카카오톡
    {
      label: t('linkToData.step3.item.toss'),
      description: t('linkToData.step3.item.description2'),
      img: tossMImg,
    }, //토스
    {
      label: t('linkToData.step3.item.naver'),
      description: t('linkToData.step3.item.description3'),
      img: naverMImg,
    }, //네이버
    {
      label: t('linkToData.step3.item.kakaobank'),
      description: t('linkToData.step3.item.description4'),
      img: kakaobankMImg,
    }, //카카오뱅크
  ];
};

//PDF내용 리스트 버튼
export const eDocumentsListButton = t => {
  return [
    { label: t('eDocuments.item3'), value: '1' }, //보험료
    { label: t('eDocuments.item4'), value: '2' }, //의료비
    { label: t('eDocuments.item5'), value: '3' }, //교육비
    { label: t('eDocuments.item6'), value: '4' }, //기부금
    { label: t('eDocuments.item7'), value: '5' }, //신용카드
    { label: t('eDocuments.item8'), value: '6' }, //주택자금
    { label: t('eDocuments.item9'), value: '7' }, //기타
    { label: t('eDocuments.item1'), value: '8' }, //건강보험
    { label: t('eDocuments.item2'), value: '9' }, //국민연금보험
  ];
};

//결과조회 모의계산, 월급날검토 탭 리스트
export const resultQueryTabs = (t, resultData, comYASetting) => {
  return [
    //모의계산
    {
      label: t('tab.tab1'),
      contentTitle: t('tab.title'),
      value: '1',
      imgSrc: antImg,
      badge: resultData?.htmPerResultTxt,
      amount: resultData?.htmPerResultMony,
      buttonList: [
        { label: t('tab.button1'), value: '1', cmd: 'YA001', view: true }, //소득공제신고서(확인용)
        {
          label: t('tab.button3'),
          value: '2',
          cmd: 'YA002',
          view: comYASetting.htmMenuType != '2',
        }, //근로소득원천징수영수증
        {
          label: t('tab.button4'),
          value: '3',
          cmd: 'YA001',
          param: '&HtmNoPaperView=j',
          view: resultData.houseConfirmPaper,
        }, //주택확인서
      ],
    },
    //월급날검토
    {
      label: t('tab.tab2'),
      contentTitle: resultData?.htmViewMagam == '1' ? t('tab.title2') : '검토중',
      value: '2',
      imgSrc: pigImg,
      amount:
        resultData?.htmViewMagam == '1' ? resultData?.htmYAResultMony || 0 : '조금만 기다려주세요!',
      badge: resultData?.htmViewMagam == '1' ? resultData?.htmYAResultTxt || '' : '',
      buttonList: [
        { label: t('tab.button2'), value: '1', cmd: 'YA001', view: true }, //소득공제신고서
        {
          label: t('tab.button3'),
          value: '2',
          cmd: 'YA002',
          param: '&HtmReceiptDateFlag=Y',
          view: true,
        }, //근로소득원천징수영수증
        {
          label: t('tab.button4'),
          value: '3',
          cmd: 'YA001',
          param: '&HtmNoPaperView=j',
          view: resultData.houseConfirmPaper,
        }, //주택
        { label: t('tab.button5'), value: '4', cmd: 'YA006', view: resultData.gibuPaper }, //기부금명세서
        { label: t('tab.button6'), value: '5', cmd: 'YA007', view: true }, //의료비
      ],
    },
  ];
};

// 연말정산 레포트
export const resultReportData = t => {
  return [
    //근로자 입력값
    {
      label: t('report.title1'),
      value: '1',
      itemList: [
        { label: t('report.item1'), key: 'htmP001' }, //총급여(전직장 포함)
        { label: t('report.item2'), key: 'htmP002' }, //인적공제
        { label: t('report.item3'), key: 'htmP003' }, //소득공제
        { label: t('report.item4'), key: 'htmP004' }, //세액공제
        { label: t('report.item5'), key: 'htmP005', fontStyle: 'body2Bold' }, //차감징수세액
      ],
    },
    //월급날 검토값
    {
      label: t('report.title2'),
      value: '2',
      itemList: [
        { label: t('report.item1'), key: 'htmM001' }, //총급여(전직장 포함)
        { label: t('report.item2'), key: 'htmM002' }, //인적공제
        { label: t('report.item3'), key: 'htmM003' }, //소득공제
        { label: t('report.item4'), key: 'htmM004' }, //세액공제
        { label: t('report.item5'), key: 'htmM005', fontStyle: 'body2Bold' }, //차감징수세액
      ],
    },
  ];
};

// AI 채팅 답변 키워드 규칙
export const AI_MESSAGE_RULES = [
  /*
    - every: keywords가 모두 존재할 경우
    - some: keywords중에 하나라도 존재할 경우
    - link: 다이렉트링크 경로 (있으면 해당 경로로 이동하는 버튼 생성)
    - linkText: 버튼에 표시될 텍스트
    - iconKey: 버튼 아이콘 키 (실제 아이콘은 컴포넌트에서 매핑)
  */
  {
    flag: 1,
    keywords: ['채팅상담', '전화상담', '상담사', '상담원'],
    condition: 'some',
  },
  {
    flag: 2,
    keywords: ['개인정보 수정'],
    condition: 'every',
  },
  {
    flag: 3,
    keywords: ['연말정산', '일정'],
    condition: 'every',
  },
  {
    flag: 4,
    keywords: ['결과조회', '초기화'],
    condition: 'every',
  },
  {
    flag: 6,
    keywords: ['전직장', '전 직장'],
    condition: 'some',
    link: '/previousEmployment',
    linkText: '전직장',
    iconKey: 'previousJob',
  },
  {
    flag: 7,
    keywords: ['보험료'],
    condition: 'every',
    link: '/deductions/insurancePremiums',
    linkText: '보험료',
    iconKey: 'insurance',
  },
  {
    flag: 8,
    keywords: ['의료비'],
    condition: 'every',
    link: '/deductions/medicalExpenses',
    linkText: '의료비',
    iconKey: 'medical',
  },
  {
    flag: 9,
    keywords: ['교육비'],
    condition: 'every',
    link: '/deductions/educationExpenses',
    linkText: '교육비',
    iconKey: 'education',
  },
  {
    flag: 10,
    keywords: ['기부금'],
    condition: 'every',
    link: '/deductions/donations',
    linkText: '기부금',
    iconKey: 'donation',
  },
  {
    flag: 11,
    keywords: ['신용카드'],
    condition: 'every',
    link: '/deductions/creditCards',
    linkText: '신용카드',
    iconKey: 'creditCard',
  },
  {
    flag: 12,
    keywords: ['주택자금'],
    condition: 'every',
    link: '/deductions/housingFunds',
    linkText: '주택자금',
    iconKey: 'housing',
  },
  {
    flag: 13,
    keywords: ['기타'],
    condition: 'every',
    link: '/deductions/otherDeductions',
    linkText: '기타공제',
    iconKey: 'etc',
  },
  {
    flag: 14,
    keywords: ['전자문서'],
    condition: 'every',
    link: '/eDocuments',
    linkText: '전자문서',
    iconKey: 'pdf',
  },
  {
    flag: 15,
    keywords: ['증빙서류'],
    condition: 'every',
    link: '/evidenceDocuments',
    linkText: '증빙서류',
    iconKey: 'document',
  },
  {
    flag: 16,
    keywords: ['부양가족'],
    condition: 'every',
    link: '/dependents',
    linkText: '부양가족',
    iconKey: 'family',
  },
];
